/**
 * Funciones para ordenar lista de clubes
 */

export const CamposOrdenamiento = {
  NOMBRE: 'nombre',
  PAIS: 'pais',
  LOCALIDAD: 'localidad',
  FUNDACION: 'fundacion',
};

/**
 * Compara dos fechas parciales (pueden ser año, año-mes, o fecha completa)
 * @param {number} anio1 - año de la primera fecha
 * @param {number} mes1 - mes de la primera fecha (puede ser null)
 * @param {number} dia1 - día de la primera fecha (puede ser null)
 * @param {number} anio2 - año de la segunda fecha
 * @param {number} mes2 - mes de la segunda fecha (puede ser null)
 * @param {number} dia2 - día de la segunda fecha (puede ser null)
 * @returns {number} - negativo si fecha1 < fecha2, 0 si son iguales, positivo si fecha1 > fecha2
 */
const compararFechasParcialesAsc = (anio1, mes1, dia1, anio2, mes2, dia2) => {
  // Normalizar null a 999 para que venga DESPUÉS en orden ascendente
  // Esto significa que una fecha incompleta viene después de una completa
  const a1 = anio1 ?? 0;
  const a2 = anio2 ?? 0;
  const m1 = mes1 ?? 999; // null → 999 (viene después)
  const m2 = mes2 ?? 999;
  const d1 = dia1 ?? 999; // null → 999 (viene después)
  const d2 = dia2 ?? 999;

  // Comparar año
  if (a1 !== a2) return a1 - a2;
  // Si años iguales, comparar mes
  if (m1 !== m2) return m1 - m2;
  // Si meses iguales, comparar día
  return d1 - d2;
};

/**
 * Ordena la lista de clubes según el campo y dirección especificados
 * @param {Array} lista - lista de clubes a ordenar
 * @param {string} campo - campo por el que ordenar (usa CamposOrdenamiento)
 * @param {boolean} ascendente - true para orden ascendente, false para descendente
 * @returns {Array} - nueva lista ordenada
 */
export const ordenarClubes = (lista, campo, ascendente = true) => {
  if (!lista || lista.length === 0) return lista;

  const listaOrdenada = [...lista];

  listaOrdenada.sort((a, b) => {
    let comparacion = 0;

    switch (campo) {
      case CamposOrdenamiento.NOMBRE:
        comparacion = (a.nombre || '').localeCompare(b.nombre || '', 'es');
        break;

      case CamposOrdenamiento.PAIS:
        comparacion = (a.pais?.nombre || '').localeCompare(b.pais?.nombre || '', 'es');
        break;

      case CamposOrdenamiento.LOCALIDAD:
        comparacion = (a.localidad?.nombre || '').localeCompare(b.localidad?.nombre || '', 'es');
        break;

      case CamposOrdenamiento.FUNDACION:
        comparacion = compararFechasParcialesAsc(
          a.anioFundacion,
          a.mesFundacion,
          a.diaFundacion,
          b.anioFundacion,
          b.mesFundacion,
          b.diaFundacion
        );
        break;

      default:
        return 0;
    }

    return ascendente ? comparacion : -comparacion;
  });

  return listaOrdenada;
};

/**
 * Obtiene la descripción legible del campo de ordenamiento
 */
export const obtenerDescripcionCampo = (campo) => {
  switch (campo) {
    case CamposOrdenamiento.NOMBRE:
      return 'Nombre';
    case CamposOrdenamiento.PAIS:
      return 'País';
    case CamposOrdenamiento.LOCALIDAD:
      return 'Localidad';
    case CamposOrdenamiento.FUNDACION:
      return 'Fundación';
    default:
      return 'Sin ordenar';
  }
};
